import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { border } from 'styles'
import { title, body } from 'styles/texts'
import { primary, black, gray } from 'styles/colors'
import {
  roomNameSelector,
  roomLastMessageTimeSelector,
  roomTitleSelector,
  roomLastMessageSelector,
  roomProfilePicture,
  roomNotificationCountSelector,
} from 'selectors'

import ProfilePicture from 'components/ProfilePicture'
import NotificationsComponent from 'components/Notifications'

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 20px;
  padding: 30px;
  min-height: 133px;
  border-bottom: ${border};
  ${props => (props.active ? 'background-color: #F8F8F8' : '')};
`

const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
`

const Name = styled.div`
  ${title};
  ${props => (props.notifications ? 'font-weight: 500' : '')};
`

const LastMessageTime = styled.div`
  ${body};
  grid-column-end: span 2;
  grid-row-end: span 2;
  color: ${props => (props.notifications ? primary : black)};
`

const Title = styled.div`
  ${body};
`

const LastMessage = styled.div`
  ${body};
  color: ${props => (props.notifications ? black : gray)};
  grid-column-end: span 2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 10px;
  align-self: end;
  ${props => (props.notifications ? 'font-weight: 500' : '')};
`

const Notifications = styled(NotificationsComponent)`
  align-self: end;
`

const Room = ({
  name,
  lastMessageTime,
  title,
  lastMessage,
  profilePicture,
  onClick,
  active,
  notifications,
}) => (
  <Wrapper onClick={onClick} active={active}>
    <ProfilePicture src={profilePicture} size="60" />
    <Content>
      <Name notifications={notifications > 0}>{name}</Name>
      <LastMessageTime notifications={notifications > 0}>
        {lastMessageTime}
      </LastMessageTime>
      <Title>{title}</Title>
      <LastMessage notifications={notifications > 0}>{lastMessage}</LastMessage>
      {notifications > 0 && <Notifications count={notifications} />}
    </Content>
  </Wrapper>
)

const mapStateToProps = (state, { roomId }) => ({
  name: roomNameSelector(state, roomId),
  lastMessageTime: roomLastMessageTimeSelector(state, roomId),
  title: roomTitleSelector(state, roomId),
  lastMessage: roomLastMessageSelector(state, roomId),
  profilePicture: roomProfilePicture(state, roomId),
  notifications: roomNotificationCountSelector(state, roomId),
})

export default connect(mapStateToProps)(Room)



// WEBPACK FOOTER //
// ./src/components/chat/Room.js